"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SavingOverlay = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _Loading = _interopRequireDefault(require("../../Loading"));

const Overlay = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: ${_blocks.spacing.extraLoose};
  font-size: 19px;
  background: rgba(255, 255, 255, ${_blocks.opacity.tint});
  z-index: ${_blocks.layer.fixedContent};
  border-radius: 0 0 ${_blocks.borderRadius.large} ${_blocks.borderRadius.large};
`;
const Saving = (0, _styledComponents.default)(_blocks.Title)`
  margin-bottom: ${_blocks.spacing.default};
  font-size: 18px;
  color: ${_blocks.palette.neutral7};
`;

const SavingOverlay = () => /*#__PURE__*/_react.default.createElement(Overlay, null, /*#__PURE__*/_react.default.createElement(Saving, null, "Saving configuration..."), /*#__PURE__*/_react.default.createElement(_Loading.default, null));

exports.SavingOverlay = SavingOverlay;